import bulkOrders from "./bulkOrders/mutations";

export default {
  ...bulkOrders,
};
